"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Determine whether the given value is a number or not.
 *
 * @param {number} num = The number to compare against.
 *
 * @example
 *
 *   isNumber(0)
 *   //=> true
 *
 *   isNumber(Infinity)
 *   //=> true
 *
 *   isNumber(NaN)
 *   //=> false
 */
function isNumber(num) {
    if (isNaN(num)) {
        return false;
    }
    return typeof num === 'number';
}
exports.isNumber = isNumber;
//# sourceMappingURL=is-number.js.map